"use client";

export function CookiePreferencesButton({ children }: { children: React.ReactNode }) {
  return (
    <button
      type="button"
      className="text-left text-foreground/80 text-sm hover:text-foreground"
      onClick={() => window.dispatchEvent(new Event("teksta:cookie-preferences"))}
    >
      {children}
    </button>
  );
}
